module.exports = __webpack_public_path__ + "static/media/image-1.2521d4bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/ConsumerBehaviour/image-1.jpg
// module id = 80
// module chunks = 0